    import React from 'react';
    import { BrowserRouter, Routes, Route } from 'react-router-dom';

    // Login / Registration Routes
    import Login from './components/login/login'; // Import your components
    import EmailVerification from './components/login/emailVerification';
    import Eula from './components/login/eula';
    import Terms from './components/login/terms';
    import ForgotPasswordModal from './components/login/modals/forgotPasswordModal';
    import PasswordResetPage from './components/login/passwordResetPage';
    
    // Navigation Routes
    import Alerts from './components/navigation/alerts';
    import Applications from './components/navigation/applications';
    import Inventory from './components/navigation/inventory';
    import Systems from './components/navigation/systems';
    import NeTERS from './components/navigation/neters';
    import HostInformation from './components/navigation/hostInformation'
    import FlowHome from './components/navigation/flow/home';
    import FlowDetails from './components/navigation/flow/details';
    import FlowAlerts from './components/navigation/flow/alerts';
    import FlowStats from './components/navigation/flow/stats';

    // Analytics Routes
    import BandwidthUsage from './components/analytics/bandwidthUsage';
    import CveInfo from './components/analytics/cveInfo';
    import CveDetails from './components/analytics/cveDetails';
    import SeveritiesFound from './components/analytics/severitiesFound';
    import SeveritiesFoundTable from './components/analytics/severitiesFoundTable';
    import SourceIps from './components/analytics/sourceIps';
    import UsersAndSystems from './components/analytics/usersAndSystems';
    import WeeklyFailedLogins from './components/analytics/weeklyFailedLogins';
    import ThreatHunting from './components/analytics/threatHunting';
    import BeaconThreathunt from './components/analytics/beaconThreathunt';
    import PTVSOverview from './components/analytics/ptvsOverview';
    import PTVSDetails from './components/analytics/ptvsDetails';
    import PTVSThreatResponse from './components/analytics/ptvsThreatResponse';
    import NISTOverview from './components/analytics/complianceDashboards/nistOverview';
    import NISTDetails from './components/analytics/complianceDashboards/nistDetails';
    import CISOverview from './components/analytics/complianceDashboards/cisOverview';
    import CISDetails from './components/analytics/complianceDashboards/cisDetails';
    import HIPAAOverview from './components/analytics/complianceDashboards/hipaaOverview';
    import HIPAADetails from './components/analytics/complianceDashboards/hipaaDetails';
    import MITREAttack from './components/analytics/complianceDashboards/mitreAttack';
    import MITREAttackDetails from './components/analytics/complianceDashboards/mitreAttackDetails';
    import PCIOverview from './components/analytics/complianceDashboards/pciOverview';
    import PCIDetails from './components/analytics/complianceDashboards/pciDetails';
    import SOCOverview from './components/analytics/complianceDashboards/socOverview';
    import SOCDetails from './components/analytics/complianceDashboards/socDetails';
    import PMOverview from './components/analytics/eMassDashboards/pmOverview'
    import ISSOOverview from './components/analytics/eMassDashboards/issoOverview'
    import EnterpriseDetails from './components/analytics/eMassDashboards/enterpriseDetails';
    import EnterpriseOverview from './components/analytics/eMassDashboards/enterpriseOverview';
    import Roadmap from './components/analytics/eMassDashboards/roadmap';
    import AOScorecard from './components/analytics/eMassDashboards/aoScorecard';
    import AoOversight from './components/analytics/eMassDashboards/aoOversight';
    import AoOversightDetails from './components/analytics/eMassDashboards/aoOversightDetails';
    import SystemDetail from './components/analytics/eMassDashboards/systemDetail';
    import SystemOverview from './components/analytics/eMassDashboards/systemOverview';
    import Trending from './components/analytics/eMassDashboards/trending';
    import PhenActivity from './components/analytics/phenActivity'

    // import OPGuide from './components/opguide';

    // Admin Routes
    import AdminAlerts from './components/admin/alerts/adminAlerts';
    import AdminApplications from './components/admin/applications/adminApplications';
    import AttackTypes from './components/admin/attackTypes';
    import ChangePassword from './components/admin/changePassword';
    import EncryptPasswords from './components/admin/encryptPasswords';
    import Groups from './components/admin/groups';
    import Metrics from './components/admin/metrics';
    import Notifications from './components/admin/notifications';
    import Options from './components/admin/options/options';
    import ProgramSettings from './components/admin/settings';
    import SlaAlerts from './components/admin/slaAlerts';
    import Simulations from './components/admin/simulations';
    import Tooltips from './components/admin/tooltips';
    import Users from './components/admin/users';

    // Help Routes
    import Features from './components/help/features';
    import InstallCstShippers from './components/help/installCstShippers';
    import InstallMacShippers from './components/help/installMacShippers';
    import InstallShippers from './components/help/shippers';
    import LinuxCstShippers from './components/help/linuxCstShippers';
    import LinuxShippers from './components/help/linuxshippers';
    import MacCstShippers from './components/help/macCstShippers';
    import OperatorGuide from './components/help/operatorGuide';
    import PhenTalk from './components/help/phenTalk';
    import Shippers from './components/admin/shippers/shippers';
    import WhatsNew from './components/help/whatsNew';
    import UserProfile from './components/help/userProfile';

    // Simulation Routes
    import Simulator from './components/simulate/simulator';
    import DisplayStigReport from './components/simulate/stig';

    // Admin Option Routes
    import ApprovalList from './components/admin/options/approvedList';
    import DenyList from './components/admin/options/denyList';
    import RequiredList from './components/admin/options/requiredList';

    // Protect Routes
    import { useUser } from './userContext';
    import AuthenticatedProtectedRoutes from './components/common/utils/authenticatedProtectedRoutesUtil';    
    import UserProtectedRoutes from './components/common/utils/userProtectedRoutesUtil';    

    //Header
    import Header from './components/banners/Header';

    //Footer
    import Footer from './components/common/banner/classificationBannerFooter';

    function Router() {

      const { userName, authenticated } = useUser();      
      const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';

      return (
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path={`${baseRoute}`} element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Login />} />
            <Route path="/stigReport" element={<DisplayStigReport />} />
            
            <Route element={<UserProtectedRoutes userName={userName} />}>
                <Route path="/emailVerification" element={<EmailVerification />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/eula" element={<Eula />} />
            </Route>
            <Route element={<AuthenticatedProtectedRoutes isAuthenticated={authenticated} />}>    
                <Route path="/adminAlerts" element={<AdminAlerts />} />
                <Route path="/adminApplications" element={<AdminApplications />} />
                <Route path="/adminAttackTypes" element={<AttackTypes />} />
                <Route path="/adminFeatures" element={<Features />} />
                <Route path="/adminNotifications" element={<Notifications />} />
                <Route path="/adminSimulations" element={<Simulations />} />
                <Route path="/adminTooltips" element={<Tooltips />} />
                <Route path="/adminWhatsNew" element={<WhatsNew />} />          
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/aoOversight" element={<AoOversight />} />
                <Route path="/aoOversightDetails" element={<AoOversightDetails />} />
                <Route path="/aoScorecard" element={<AOScorecard />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/applications/:paramFilter" element={<Applications />} />
                <Route path="/bandwidthUsage" element={<BandwidthUsage />} />
                <Route path="/beaconThreathunt" element={<BeaconThreathunt />} />
                <Route path="/changePassword" element={<ChangePassword />} />
                <Route path="/encryptPasswords" element={<EncryptPasswords />} />
                <Route path="/cisDetails" element={<CISDetails />} />
                <Route path="/cisOverview" element={<CISOverview />} /> 
                <Route path="/cveDetails" element={<CveDetails />} />
                <Route path="/cveInfo" element={<CveInfo />} />
                <Route path="/enterpriseDetails" element={<EnterpriseDetails />} />
                <Route path="/enterpriseOverview" element={<EnterpriseOverview />} />
                <Route path="/features" element={<Features />} />
                <Route path="/flow/alerts" element={<FlowAlerts />} />
                <Route path="/flow/details" element={<FlowDetails />} />
                <Route path="/flow/home" element={<FlowHome />} />
                <Route path="/flow/stats" element={<FlowStats />} />
                <Route path="/forgotPassword" element={<ForgotPasswordModal />} />
                <Route path="/groups" element={<Groups />} />  
                <Route path="/hipaaDetails" element={<HIPAADetails />} />
                <Route path="/hipaaOverview" element={<HIPAAOverview />} /> 
                <Route path="/hostInformation" element={<HostInformation />} /> 
                <Route path="/installShippers" element={<InstallShippers />} />
                <Route path="/installCstShippers" element={<InstallCstShippers />} />
                <Route path="/installMacShippers" element={<InstallMacShippers />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/issoOverview" element={<ISSOOverview />} />
                <Route path="/linuxShippers" element={<LinuxShippers />} />
                <Route path="/linuxCstShippers" element={<LinuxCstShippers />} />
                <Route path="/macCstShippers" element={<MacCstShippers />} />
                <Route path="/metrics" element={<Metrics />} />
                <Route path="/mitreAttack" element={<MITREAttack />} />
                <Route path="/mitreAttackDetails" element={<MITREAttackDetails />} />
                <Route path="/neters" element={<NeTERS />} />
                <Route path="/nistOverview" element={<NISTOverview />} />
                <Route path="/nistDetails" element={<NISTDetails />} />
                <Route path='/operatorGuide' element={<OperatorGuide />} />
                <Route path="/options" element={<Options />} />
                <Route path="/optionsApprovedList" element={<ApprovalList />} />
                <Route path="/optionsDenyList" element={<DenyList />} />
                <Route path="/optionsRequiredList" element={<RequiredList />} />
                <Route path="/pciDetails" element={<PCIDetails />} />
                <Route path="/pciOverview" element={<PCIOverview />} />
                <Route path="/phenActivity" element={<PhenActivity />} />
                <Route path="/phenTalk" element={<PhenTalk />} />
                <Route path="/pmOverview" element={<PMOverview />} />
                <Route path="/ptvsDetails" element={<PTVSDetails />} />
                <Route path="/ptvsOverview" element={<PTVSOverview />} />
                <Route path="/ptvsThreatResponse" element={<PTVSThreatResponse />} />
                <Route path="/roadmap" element={<Roadmap />} />
                <Route path="/settings" element={<ProgramSettings />} />
                <Route path="/severitiesFound" element={<SeveritiesFound />} />
                <Route path="/severitiesFoundTable" element={<SeveritiesFoundTable />} />
                <Route path="/shippers" element={<Shippers />} />
                <Route path="/simulator" element={<Simulator />} />
                <Route path="/slaAlerts" element={<SlaAlerts />} />
                <Route path="/socDetails" element={<SOCDetails />} />
                <Route path="/socOverview" element={<SOCOverview />} />
                <Route path="/sourceIps" element={<SourceIps />} />
                <Route path="/systemDetail" element={<SystemDetail />} />
                <Route path="/systemOverview" element={<SystemOverview />} />
                <Route path="/systems" element={<Systems/> } />
                <Route path="/systems/:paramFilter" element={<Systems/> } />
                <Route path="/threatHunting" element={<ThreatHunting />} />
                <Route path="/trending" element={<Trending />} />
                <Route path="/users" element={<Users />} />
                <Route path="/usersAndSystems" element={<UsersAndSystems />} />
                <Route path="/userProfile" element={<UserProfile />} />
                <Route path="/weeklyFailedLogins" element={<WeeklyFailedLogins />} />
                <Route path="/whatsNew" element={<WhatsNew />} />
            </Route>
            <Route path="/reset-password" element={<PasswordResetPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      );
    }

    export default Router;
